import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
export const protobufPackage = "com.snap.camerakit.v3";
export enum CameraKitFlavor {
    CAMERA_KIT_FLAVOR_UNSET = 0,
    CAMERA_KIT_FLAVOR_DEBUG = 1,
    CAMERA_KIT_FLAVOR_RELEASE = 2,
    UNRECOGNIZED = -1
}
export enum CameraKitConnectivityType {
    CAMERA_KIT_CONNECTIVITY_TYPE_UNSET = 0,
    CAMERA_KIT_CONNECTIVITY_TYPE_WIFI = 1,
    CAMERA_KIT_CONNECTIVITY_TYPE_MOBILE = 2,
    CAMERA_KIT_CONNECTIVITY_TYPE_UNREACHABLE = 3,
    CAMERA_KIT_CONNECTIVITY_TYPE_BLUETOOTH = 4,
    UNRECOGNIZED = -1
}
export enum CameraKitEnvironment {
    CAMERA_KIT_ENVIRONMENT_UNSET = 0,
    CAMERA_KIT_ENVIRONMENT_STAGING = 1,
    CAMERA_KIT_ENVIRONMENT_PRODUCTION = 2,
    UNRECOGNIZED = -1
}
export interface ExtensionEventBase {
    extensionName: string;
    extensionVersion: string;
    deviceCluster: string;
    cameraKitVersion: string;
    lensCoreVersion: string;
    deviceModel: string;
    cameraKitFlavor: CameraKitFlavor;
    appId: string;
    deviceConnectivity: CameraKitConnectivityType;
    sessionId: string;
    cameraKitEnvironment: CameraKitEnvironment;
}
function createBaseExtensionEventBase(): ExtensionEventBase {
    return {
        extensionName: "",
        extensionVersion: "",
        deviceCluster: "0",
        cameraKitVersion: "",
        lensCoreVersion: "",
        deviceModel: "",
        cameraKitFlavor: 0,
        appId: "",
        deviceConnectivity: 0,
        sessionId: "",
        cameraKitEnvironment: 0,
    };
}
export const ExtensionEventBase: MessageFns<ExtensionEventBase> = {
    encode(message: ExtensionEventBase, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
        if (message.extensionName !== "") {
            writer.uint32(10).string(message.extensionName);
        }
        if (message.extensionVersion !== "") {
            writer.uint32(18).string(message.extensionVersion);
        }
        if (message.deviceCluster !== "0") {
            writer.uint32(24).int64(message.deviceCluster);
        }
        if (message.cameraKitVersion !== "") {
            writer.uint32(34).string(message.cameraKitVersion);
        }
        if (message.lensCoreVersion !== "") {
            writer.uint32(42).string(message.lensCoreVersion);
        }
        if (message.deviceModel !== "") {
            writer.uint32(50).string(message.deviceModel);
        }
        if (message.cameraKitFlavor !== 0) {
            writer.uint32(56).int32(message.cameraKitFlavor);
        }
        if (message.appId !== "") {
            writer.uint32(66).string(message.appId);
        }
        if (message.deviceConnectivity !== 0) {
            writer.uint32(72).int32(message.deviceConnectivity);
        }
        if (message.sessionId !== "") {
            writer.uint32(82).string(message.sessionId);
        }
        if (message.cameraKitEnvironment !== 0) {
            writer.uint32(88).int32(message.cameraKitEnvironment);
        }
        return writer;
    },
    decode(input: BinaryReader | Uint8Array, length?: number): ExtensionEventBase {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseExtensionEventBase();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.extensionName = reader.string();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.extensionVersion = reader.string();
                    continue;
                }
                case 3: {
                    if (tag !== 24) {
                        break;
                    }
                    message.deviceCluster = reader.int64().toString();
                    continue;
                }
                case 4: {
                    if (tag !== 34) {
                        break;
                    }
                    message.cameraKitVersion = reader.string();
                    continue;
                }
                case 5: {
                    if (tag !== 42) {
                        break;
                    }
                    message.lensCoreVersion = reader.string();
                    continue;
                }
                case 6: {
                    if (tag !== 50) {
                        break;
                    }
                    message.deviceModel = reader.string();
                    continue;
                }
                case 7: {
                    if (tag !== 56) {
                        break;
                    }
                    message.cameraKitFlavor = reader.int32() as any;
                    continue;
                }
                case 8: {
                    if (tag !== 66) {
                        break;
                    }
                    message.appId = reader.string();
                    continue;
                }
                case 9: {
                    if (tag !== 72) {
                        break;
                    }
                    message.deviceConnectivity = reader.int32() as any;
                    continue;
                }
                case 10: {
                    if (tag !== 82) {
                        break;
                    }
                    message.sessionId = reader.string();
                    continue;
                }
                case 11: {
                    if (tag !== 88) {
                        break;
                    }
                    message.cameraKitEnvironment = reader.int32() as any;
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    create<I extends Exact<DeepPartial<ExtensionEventBase>, I>>(base?: I): ExtensionEventBase {
        return ExtensionEventBase.fromPartial(base ?? ({} as any));
    },
    fromPartial<I extends Exact<DeepPartial<ExtensionEventBase>, I>>(object: I): ExtensionEventBase {
        const message = createBaseExtensionEventBase();
        message.extensionName = object.extensionName ?? "";
        message.extensionVersion = object.extensionVersion ?? "";
        message.deviceCluster = object.deviceCluster ?? "0";
        message.cameraKitVersion = object.cameraKitVersion ?? "";
        message.lensCoreVersion = object.lensCoreVersion ?? "";
        message.deviceModel = object.deviceModel ?? "";
        message.cameraKitFlavor = object.cameraKitFlavor ?? 0;
        message.appId = object.appId ?? "";
        message.deviceConnectivity = object.deviceConnectivity ?? 0;
        message.sessionId = object.sessionId ?? "";
        message.cameraKitEnvironment = object.cameraKitEnvironment ?? 0;
        return message;
    },
};
type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;
export type DeepPartial<T> = T extends Builtin ? T : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>> : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>> : T extends {
    $case: string;
} ? {
    [K in keyof Omit<T, "$case">]?: DeepPartial<T[K]>;
} & {
    $case: T["$case"];
} : T extends {} ? {
    [K in keyof T]?: DeepPartial<T[K]>;
} : Partial<T>;
type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P : P & {
    [K in keyof P]: Exact<P[K], I[K]>;
} & {
    [K in Exclude<keyof I, KeysOfUnion<P>>]: never;
};
export interface MessageFns<T> {
    encode(message: T, writer?: BinaryWriter): BinaryWriter;
    decode(input: BinaryReader | Uint8Array, length?: number): T;
    create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
    fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
